import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useCart } from '@/hooks/useCart';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { CartDrawer } from '@/components/CartDrawer';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Home } from '@/pages/Home';
import { Shop } from '@/pages/Shop';
import { ProductDetail } from '@/pages/ProductDetail';
import { Checkout } from '@/pages/Checkout';
import { About } from '@/pages/About';
import { Contact } from '@/pages/Contact';
import { Impressum } from '@/pages/Impressum';
import { Datenschutz } from '@/pages/Datenschutz';
import { AGB } from '@/pages/AGB';
import { Admin } from '@/pages/Admin';
import { AdminLogin } from '@/pages/AdminLogin';
import { NotFound } from '@/pages/NotFound';

function App() {
  const { cart, isOpen, setIsOpen, addItem, removeItem, updateQuantity, clearCart, totalItems, totalPrice } = useCart();

  return (
    <HelmetProvider>
      <div className="min-h-screen flex flex-col bg-surface-primary">
        <Navbar cartCount={totalItems} onCartClick={() => setIsOpen(true)} />

        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop onAddToCart={addItem} />} />
            <Route path="/shop/:id" element={<ProductDetail onAddToCart={addItem} />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/ueber-uns" element={<About />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/admin" element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            } />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <Footer />

        <CartDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} cart={cart} totalPrice={totalPrice} onUpdateQuantity={updateQuantity} onRemove={removeItem} />
      </div>
    </HelmetProvider>
  );
}

export default App;